import {SOPostSubscription} from '../../core/subscription/so-post-subscription';
import {SubscriptionCore} from './subscription.core';
import {SOGetSubscription} from '../../core/subscription/so-get-subscription';
import {FormField, SelectionOption} from 'lionheartland';
import {postSubscriptionFormFieldOptions} from './post-subscription-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';
import {PriceCore} from '../price/price.core';
import {SOGetPrice} from '../../core/price/so-get-price';

export class RAPostSubscription extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postSubscriptionFormFieldOptions);

  RequestClass = SOPostSubscription

  constructor(
    public entityCore: SubscriptionCore
  ) {
    super();
    if (postSubscriptionFormFieldOptions.organization) {
      postSubscriptionFormFieldOptions.organization.makeCore = true;
    }
    if (postSubscriptionFormFieldOptions.price) {
      postSubscriptionFormFieldOptions.price.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
      ),
      this.getFormValueFromIdentifier(
        'price',
        SOGetPrice,
      ),
      this.getFormValueFromIdentifier('status'),
      this.getFormValueFromIdentifier('exRef'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}